import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';

import ContentLangButton from 'src/components/common/ContentLangBtn';

// TODO refaire ce composant simplement et proprement
const mapStateToProps = state => ({
  currentLang: state.campaignEditor.actions.modifiedCurrentAction.language,
});

const Connected = connect(mapStateToProps, {
  onContentLangChange: value => ({ type: 'ON_CONTENT_LANG_CHANGE', value }),
})(props => {
  const { t } = useTranslation();
  return <ContentLangButton {...props} title={t('smartmessaging.tooltip.contentLangButton')} />;
});

export default Connected;
